@use "foundation/_colors.scss";

.sms-form {
  .field {
    width: 85%;
    margin: 0 auto;

    label {
      padding-bottom: 0.5em;
      color: colors.$tertiary-brand-color;

      &.error-message {
        width: 100%;
        color: colors.$error-color;
      }
    }
  }

  .sms-form-submit {
    margin: 1em auto;
  }

  .svg-icon-mobile-alert {
    svg {
      width: 8em;
      height: auto;
      cursor: pointer;

      &:first-child {
        padding-right: 0.5em;
      }
    }
  }
}
